import classnames from 'classnames';
import type { ReactNode } from 'react';
import PanelBody from '@/shared/ui/Panel/body';
import PanelTitle from '@/shared/ui/Panel/title';

type PanelProps = {
  title?: string;
  children: ReactNode;
  className?: string;
  stickyTitle?: boolean;
};
export default function Panel({ title, children, className, stickyTitle }: PanelProps) {
  return (
    <div className={classnames('panel', { 'panel-sticky-title': stickyTitle }, className)}>
      {title && <PanelTitle>{title}</PanelTitle>}
      {children}
    </div>
  );
}

export { Panel, PanelBody, PanelTitle };
